import { useState } from "react";
import { useTitle, freshChatTitle } from "./helpers";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const StickyChat = () => {
  const [chatload, setChatload] = useState(false);
  const [disablebtn, setDisablebtn] = useState(false);
  const title = useTitle();

  const handleClick = () => {
    freshChatTitle(title);
    setDisablebtn(true);
    setTimeout(() => {
      setChatload(!chatload);
      setDisablebtn(false);
    }, 3000);
  };

  return (
    <>
      {!chatload ? (
        <button id="frsh-chat" onClick={() => handleClick()} disabled={disablebtn}>
          <div className={classNames("bg-[#16283d] border border-[#16283d]", "d-hotline h-btn")}>
            <div id="chat-icon"></div>
            <div>
              <span aria-hidden="true"></span>
            </div>
          </div>
        </button>
      ) : null}
    </>
  );
};

export default StickyChat;
